import { ElementType } from 'react';

const REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref');
const REACT_MEMO_TYPE = Symbol.for('react.memo');

type AnyProps = Record<string, unknown>;
type ComponentLike = ElementType<AnyProps>;

/**
 * Returns the component when `source` is an SVG import (via vite-plugin-svgr) or a module whose
 * default export is one, and `null` for `{ uri }` sources.
 */
export function resolveSvgComponent(source: unknown): ComponentLike | null {
  const direct = isComponentLike(source) ? source : undefined;
  const fromDefault = direct ? undefined : getDefaultExport(source);
  const candidate = direct ?? fromDefault;
  return isComponentLike(candidate) ? candidate : null;
}

function isComponentLike(value: unknown): value is ComponentLike {
  if (typeof value === 'function') {
    return true;
  }
  if (value && typeof value === 'object') {
    const maybe = value as { $$typeof?: symbol };
    return maybe.$$typeof === REACT_FORWARD_REF_TYPE || maybe.$$typeof === REACT_MEMO_TYPE;
  }
  return false;
}

function getDefaultExport(value: unknown): unknown {
  if (value && typeof value === 'object' && 'default' in (value as Record<string, unknown>)) {
    return (value as Record<string, unknown>).default;
  }
  return undefined;
}
